// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__UtPxF","row":"styles_row__5PZQ6"};